import React, { useEffect } from 'react'
import { Outlet, useMatch } from 'react-router-dom'
import styled from 'styled-components'
import { Header } from '../Components/Header/Header'
import { Sidebar } from '../Components/Sidebar/Sidebar'
import { isTokenExpired, isTokenExpiringSoon } from '../services/tokenUtils'
import { store } from '../app/store'
import { apiSlice } from '../features/api/apiSlice'
import { toast } from 'react-hot-toast'
export const Layout = () => {
  let login = useMatch('/login')
  let change = useMatch('/changePassword/:token')
  let dashboard = useMatch('/')
  let match = false;
  if (login || dashboard || change) {
    match = true;
  }

  // Proactive token validation
  useEffect(() => {
    // Skip token validation on login/change password pages
    if (login || change) {
      return;
    }

    // Function to handle automatic logout
    const handleAutoLogout = () => {
      // Save current path for restoration after login
      const currentPath = window.location.pathname + window.location.search;
      sessionStorage.setItem('redirectPath', currentPath);
      sessionStorage.setItem('autoLogout', 'true');
      
      // Clear localStorage
      localStorage.clear();
      
      // Reset Redux state
      store.dispatch(apiSlice.util.resetApiState());
      
      // Navigate to login
      window.location.href = '/login';
    };

    // Function to show token expiry warning
    const showTokenWarning = () => {
      toast.error("Your session will expire soon. Please save your work.", {
        duration: 5000,
        position: 'top-center'
      });
    };

    // Check token on component mount
    if (isTokenExpired()) {
      handleAutoLogout();
      return;
    }

    // Check if token is expiring soon (5 minutes)
    if (isTokenExpiringSoon(5)) {
      showTokenWarning();
    }

    // Set up periodic token validation (every 2 minutes)
    const tokenCheckInterval = setInterval(() => {
      if (isTokenExpired()) {
        clearInterval(tokenCheckInterval);
        handleAutoLogout();
      } else if (isTokenExpiringSoon(5)) {
        showTokenWarning();
      }
    }, 120000); // Check every 2 minutes

    // Cleanup interval on component unmount
    return () => {
      clearInterval(tokenCheckInterval);
    };
  }, [login, change]);
  return (
    <Main>
      <Sidebar />
      <Container match={match}>
        <Header />
        <OutletSection match={match}>
          <Outlet />
        </OutletSection>
      </Container>
    </Main>
  )
}

const Main = styled.div`
display: flex;
flex-direction: column;
overflow: hidden;
`
const Container = styled.div`

`

const OutletSection = styled.div`
  width: ${props => props.match ? '100vw' : 'calc(100vw - 20vw)'};
  margin-left: ${props => props.match ? 'none' : '20vw'};
  margin-top: ${props => props.match ? 'none' : '10vh'};
  transition: all 0.3s ease-in-out;
  
  @media (max-width: 1024px) {
    width: ${props => props.match ? '100vw' : 'calc(100vw - 25vw)'};
    margin-left: ${props => props.match ? 'none' : '25vw'};
    margin-top: ${props => props.match ? 'none' : '8vh'};
  }
  
  @media (max-width: 768px) {
    width: ${props => props.match ? '100vw' : 'calc(100vw - 30vw)'};
    margin-left: ${props => props.match ? 'none' : '30vw'};
    margin-top: ${props => props.match ? 'none' : '7vh'};
  }
  
  @media (max-width: 600px) {
    width: 100vw;
    margin-left: 0;
    margin-top: ${props => props.match ? 'none' : '7vh'};
  }
`